import React from 'react';
import Header from './header/Header';
import Footer from './footer/Footer';

type Props = {
  children: React.ReactNode;
};

const AppLayout: React.FC<Props> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />

      <main className="flex-1 m-0 ">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default AppLayout;